import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'recompose';
import { consumerFirebase } from '../../config';
import { StateContext } from '../../session/store';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import logo from '../../assets/images/banner.png'
import logo1 from '../../assets/images/logoydireccion.png'


const styles = theme => ({
  container:{
    flexDirection:'column',
    justifyContent:'flex-start'
  },
  logoImage:{
    justifyContent:'center',
    marginLeft:'2em',
    width: '100%'
  },
  logoImage1:{
    justifyContent:'flex-start',
    marginLeft:'2em',
    width: '25%'
  }
});

class Footer extends Component{

  static contextType = StateContext;

  state = {
    firebase : null
  };

  componentDidMount() {
    const { firebase } = this.state; //local state
    const [{ session }, dispatch ] = this.context; //global state

    if(firebase.auth.currentUser !== null && !session) {
      firebase.db
      .collection("Usuarios")
      .doc(firebase.auth.currentUser.uid)
      .get()
      .then(doc => {
        const userDB = doc.data();
        dispatch({
          type : "START_SESSION",
          session: userDB,
          authenticated: true
        })
      })
    }

  }

  static getDerivedStateFromProps(nextProps, prevState){
    let newObj = {};
    if(nextProps.firebase !== prevState.firebase){
      newObj.firebase = nextProps.firebase
    }
    return newObj;
  }

  render(){
    
    const [{session}, dispatch] = this.context;
    const { classes, theme } = this.props;

    return session ? ( session.authenticated ? (
  
         <Container className={classes.container}>
            <Box width="100%" my={10}>
                <img src={logo1}  className={classes.logoImage1} />
                <img src={logo}  className={classes.logoImage} />
            </Box>
        </Container>
    
    )
    :null
    )
    :null;
  }
}

export default compose(
  consumerFirebase,
  withStyles(styles, { withTheme: true })
)(Footer);